import { format } from 'date-fns';
import { ActivityLogFromAPI } from './fullContentDiffViewerTypes';

export const getEventTypeLabel = (eventType: string): string => {
  switch (eventType) {
    case 'CONTENT_DRAFT_SAVED':
      return 'Draft Saved';
    case 'CONTENT_PUBLISHED':
      return 'Published';
    case 'CONTENT_REVERTED':
      return 'Reverted';
    case 'CONTENT_AI_GENERATED':
      return 'AI Generated';
    case 'CONTENT_AI_REFINED':
      return 'AI Refined';
    default:
      return eventType.replace(/_/g, ' ');
  }
};

export const formatVersionDate = (timestamp: string): string => {
  try {
    return format(new Date(timestamp), 'MMM dd, yyyy');
  } catch {
    return timestamp;
  }
};

export const formatVersionTime = (timestamp: string): string => {
  try {
    return format(new Date(timestamp), 'HH:mm');
  } catch {
    return timestamp;
  }
};

export const formatVersionTimestamp = (timestamp: string): string => {
  try {
    return format(new Date(timestamp), "MMM dd, yyyy 'at' HH:mm");
  } catch {
    return timestamp;
  }
};

export const getInitiatorDisplayName = (version: ActivityLogFromAPI): string =>
  version.initiatedByDescription?.name ||
  (version.initiatedByType === 'ADMIN_USER' ? 'Admin User' : 'Contact');

export const getAssociatedModelDisplay = (version: ActivityLogFromAPI): string => {
  if (version.associatedModelDescription) {
    return (
      version.associatedModelDescription.name ||
      version.associatedModelDescription.contactName ||
      version.associatedModelDescription.fundOpportunityName ||
      version.associatedModelDescription.entityName ||
      'Unknown Model'
    );
  }
  return `${version.associatedModelType} - ${version.associatedModelExternalId}`;
};

export const hasVersionDiffPaths = (version: ActivityLogFromAPI): boolean =>
  Boolean(version.originalContentPath && version.newContentPath);
